// Same as backend defaults.
export const DEFAULT_SETTINGS = {
  customerImportStages: ['closedwon'],
  signedQuoteStage: 'closedwon',
  pdfSyncOnSign: true,
  dealAmountSync: true
} as const

// Keeps the switches and selects in the settings card the same width.
export const SETTINGS_FIELD_WIDTH = '336px'

// Height the settings placeholders (skeleton, spinner) occupy while loading.
export const SETTINGS_PLACEHOLDER_HEIGHT = '280px'
